import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const PeakHoursHeatmap = ({ data }) => {
  if (!data || data?.length === 0) {
    return (
      <div className="bg-card rounded-xl shadow-md p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Peak Hours Analysis</h2>
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="Clock" size={48} className="text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No peak hours data available</p>
        </div>
      </div>
    );
  }

  // Find peak hour
  const peakHour = data?.reduce((max, hour) => hour?.count > max?.count ? hour : max, data?.[0]);

  return (
    <div className="bg-card rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-semibold text-foreground">Peak Hours Analysis</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Busiest time: <span className="font-semibold text-foreground">{peakHour?.label}</span> with {peakHour?.count} visits
          </p>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>Hourly breakdown</span>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
          <XAxis
            dataKey="label"
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '11px' }}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis
            stroke="var(--color-muted-foreground)"
            style={{ fontSize: '12px' }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              borderRadius: '8px',
              color: 'var(--color-foreground)'
            }}
          />
          <Legend />
          <Bar
            dataKey="weekday"
            name="Weekday"
            fill="var(--color-primary)"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="weekend"
            name="Weekend"
            fill="var(--color-accent)"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PeakHoursHeatmap;